{
  "verified": "Vérifié",
  "iv_status": {
    "verified": "Vérifié",
    "pending": "En attente",
    "attention": "Attention"
  },
  "zoom_in": "Zoom avant",
  "zoom_out": "Zoom arrière",
  "rotate": "Rotation",
  "close": "Fermer",
  "esc_to_close": "Appuyez sur ESC pour fermer",
  "play": "Jouer",
  "pause": "Pause",
  "mute": "Muet",
  "unmute": "Unmute",
  "enter_full_screen": "Entrer dans le plein écran",
  "exit_full_screen": "Quitter le plein écran",
  "video_not_supported": "Votre navigateur ne prend pas en charge la balise vidéo.",
  "skip_forward": "Sauter en avant",
  "skip_backward": "Sauter en arrière",
  "loading": "Chargement",
  "loading_video": "Chargement de la vidéo...",
  "loading_data_description": "Veuillez patienter pendant que nous chargeons vos données. Cela ne sera pas long.",
  "no_results": "Pas de résultats",
  "nothing_found": "Aucun résultat trouvé",
  "save_changes": "Enregistrer les modifications",
  "saved_exclamation": "Sauvé !",
  "saving": "Économiser",
  "validating": "Validation",
  "error": "Erreur",
  "optional": "En option",
  "search_property": "Recherche de biens",
  "reset_search": "Réinitialiser la recherche",
  "no_items_to_show": "Pas d'articles à montrer",
  "showing_range_of_total_items": "Affichage de {{range}} of {{total}} items",
  "rows_per_page": "Lignes par page",
  "page_of_pages": "Page {{page}} de {{pages}}",
  "go_to_first_page": "Aller à la première page",
  "go_to_previous_page": "Aller à la page précédente",
  "go_to_next_page": "Aller à la page suivante",
  "go_to_last_page": "Aller à la dernière page",
  "sort_in_asc": "Trier par ordre croissant",
  "sort_in_desc": "Trier par ordre décroissant",
  "clear_sorting": "Tri clair",
  "sort_a_z": "Trier A → Z",
  "sort_z_a": "Trier Z → A",
  "reach_us_at_email": "Contactez notre service d'assistance à l'adresse support@chekin.com",
  "please_wait": "Veuillez patienter",
  "feature_coming_soon": "Prochainement",
  "feature_coming_soon_description": "Cette fonctionnalité est en cours de développement et sera bientôt disponible. Restez informés des mises à jour!",
  "beta": "Bêta",
  "download_all": "Télécharger tout",
  "entry_forms": "Formulaires d'inscription",
  "tutorial": "Tutoriel",
  "liveness_video": "Vidéo de preuve de vie",
  "reviews": "Commentaires",
  "learn_more": "En savoir plus",
  "this_cannot_be_reverted": "This cannot be reverted",
  "delete": "Delete",
  "cancel": "Cancel",
  "you_have_made_changes": "You have made changes",
  "would_you_like_to_save_them": "Would you like to save them?",
  "save": "Save",
  "dont_save": "Don't save",
  "copied_exclamation": "Copié !",
  "search_placeholder": "Recherche...",
  "type_to_search": "Tapez pour rechercher...",
  "loading_more": "Chargement...",
  "no_options": "Pas d'options",
  "select_option": "Sélectionner une option",
  "clear_all": "Tout effacer",
  "remove_item": "Supprimer {{label}}",
  "upload_file": "Télécharger le fichier",
  "download_attachment": "Télécharger la pièce jointe",
  "remove_file": "Supprimer le fichier",
  "open_calendar": "Calendrier ouvert",
  "clear_dates": "Effacer les dates",
  "select_dates": "Sélectionner les dates",
  "pick_date_range": "Choisissez une plage de dates",
  "from": "De",
  "to": "Pour",
  "pick_month": "Choisissez un mois",
  "pick_date": "Choisissez une date",
  "month": "Mois",
  "day": "Jour",
  "year": "Année",
  "done": "Terminé",
  "wrong_period_of_dates": "La période sélectionnée n'est pas valide",
  "date_range_max_days_error_one": "L'intervalle ne peut excéder {{count}} jour",
  "date_range_max_days_error_other": "L'intervalle ne peut excéder {{count}} jours",
  "date_range_min_days_error_one": "L'intervalle doit être d'au moins {{count}} jour",
  "date_range_min_days_error_other": "L'intervalle doit être d'au moins {{count}} jours",
  "past_dates": "La date ne peut être antérieure à {{minDate}}_.",
  "future_dates": "La date ne peut être postérieure à {{maxDate}}_.",
  "signature_placeholder_text": "Signez à l'intérieur de cette boîte.<br/> Utilisez votre doigt.<br/> Tapez pour commencer.",
  "open_devices_camera": "Ouvrir l'appareil photo de l'appareil",
  "place_document_inside_frame": "Placez votre document à l'intérieur du cadre",
  "close_other_application_that_may_be_using_your_camera": "Fermez les autres applications qui peuvent utiliser votre appareil photo",
  "if_you_use_external_camera_disconnect_and_reconnect": "Si vous utilisez un appareil photo externe, déconnectez-le et reconnectez-le",
  "close_the_browser_re_open_it": "Fermer le navigateur et le rouvrir",
  "camera_errors": {
    "experiencing_camera_issues": "Vous avez des problèmes avec l'appareil photo ?",
    "chekin_cant_use_your_camera": "Chekin ne peut pas utiliser votre appareil photo",
    "please_try_a_different_browser": "Votre appareil photo ne fonctionne pas dans ce navigateur. Veuillez essayer d'ouvrir le lien dans un autre navigateur.",
    "permissions_denied": "Permission refusée",
    "camera_permissions_denied": "L'appareil photo ne s'ouvre pas ? Veillez à autoriser le navigateur à utiliser l'appareil photo.",
    "no_camera_device_found": "Aucun appareil photo n'a été trouvé. Veuillez connecter un appareil photo.",
    "constraints_camera_error": "Les contraintes ne peuvent être satisfaites par les dispositifs disponibles.",
    "safari_camera_error": "Safari n'a pas pu satisfaire aux exigences de la caméra",
    "try_chrome_or_firefox": "Veuillez essayer Chrome ou Firefox"
  },
  "clear": "Clair",
  "show_less": "Montrer moins",
  "show_more": "Afficher plus",
  "tap_here_to_sign": "Cliquez ici pour signer",
  "click_here_to_sign": "Cliquez ici pour signer",
  "prefix": "Préfixe",
  "prefix_required": "Le préfixe est obligatoire",
  "reset": "Remise à zéro",
  "show_password": "Afficher le mot de passe",
  "hide_password": "Cacher le mot de passe",
  "increment": "Incrément",
  "decrement": "Décroissance",
  "create_option": "Créer \"{{input}}\"",
  "year_out_of_range": "L'année doit être comprise entre {{min}} et {{max}}.",
  "clear_date": "Date limite",
  "select_date": "Sélectionner la date",
  "draw_signature_here": "Apposez votre signature ici",
  "signature_hint": "Utilisez votre souris ou votre doigt",
  "clear_signature": "Signature lisible",
  "draw_signature_here_mobile": "Signez de votre main",
  "signature_hint_mobile": "Utilisez votre doigt",
  "camera_access_needed": "Accès à l'appareil photo requis",
  "camera_access_needed_text": "Autorisez l'accès à l'appareil photo pour prendre la photo. Si l'accès est bloqué, activez l'appareil photo dans les paramètres de votre navigateur, puis réessayez.",
  "dialog": "Boîte de dialogue"
}
